export default __webpack_public_path__ + "static/media/016.54d3b8fa.webp";